export default class Preusmeritev {
  _active = null
  _excludedIds = null
  _id = null
  _name = null
  _number = null
  _redirectOptions = null
  _time = null
  _timeOptions = null
  _selectedRedirectOption = null
  _disabled = false
  _disabledMessage = ''
  _canEnableRedirectOptionNumber = false
  _canEnableRedirectOptionVoicemail = false

  static createFromResponseItem (item) {
    let out = new Preusmeritev()
    out._id = item.id
    out._name = item.name
    out._active = item.active
    out._excludedIds = item.excludedIds || null
    out._number = item.number || null
    out._redirectOptions = item.redirectOptions || null
    out._time = item.time || null
    out._timeOptions = item.timeOptions || null
    out._disabled = false
    out._disabledMessage = ''
    if (item.redirectOptions != null) {
      let numberTypeExists = false
      item.redirectOptions.forEach(redirect => {
        if (redirect.type === 'number') {
          numberTypeExists = true
          if (redirect.canEnable === true) {
            out._canEnableRedirectOptionNumber = true
          }
        }
        if (redirect.type === 'voicemail' && redirect.canEnable === true) {
          out._canEnableRedirectOptionVoicemail = true
        }
        if (redirect.active) {
          out._selectedRedirectOption = redirect.type
        }
      })
      if (out._selectedRedirectOption == null && numberTypeExists) {
        out._selectedRedirectOption = 'number'
      }
    }

    return out
  }

  redrawRedirectOptions () {
    if (this._redirectOptions !== null) {
      this._redirectOptions.forEach((item) => {
        item.active = item.type === this._selectedRedirectOption
      })
    }
  }

  get active () {
    return this._active
  }

  set active (value) {
    this._active = value
  }

  get excludedIds () {
    return this._excludedIds
  }

  set excludedIds (value) {
    this._excludedIds = value
  }

  get id () {
    return this._id
  }

  set id (value) {
    this._id = value
  }

  get name () {
    return this._name
  }

  set name (value) {
    this._name = value
  }

  get number () {
    return this._number
  }

  set number (value) {
    this._number = value
  }

  get redirectOptions () {
    return this._redirectOptions
  }

  set redirectOptions (value) {
    this._redirectOptions = value
  }

  get time () {
    return this._time
  }

  set time (value) {
    this._time = value
  }

  get timeOptions () {
    return this._timeOptions
  }

  set timeOptions (value) {
    this._timeOptions = value
  }

  get selectedRedirectOption () {
    return this._selectedRedirectOption
  }

  set selectedRedirectOption (value) {
    this._selectedRedirectOption = value
  }

  get disabled () {
    return this._disabled
  }

  set disabled (value) {
    this._disabled = value
  }

  get disabledMessage () {
    return this._disabledMessage
  }

  set disabledMessage (value) {
    this._disabledMessage = value
  }

  get canEnableRedirectOptionNumber () {
    return this._canEnableRedirectOptionNumber
  }

  set canEnableRedirectOptionNumber (value) {
    this._canEnableRedirectOptionNumber = value
  }

  get canEnableRedirectOptionVoicemail () {
    return this._canEnableRedirectOptionVoicemail
  }

  set canEnableRedirectOptionVoicemail (value) {
    this._canEnableRedirectOptionVoicemail = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/Prikljucek/Telefonija/Umts/Preusmeritev.js